var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.222,
    height: 69.958,
    viewBox: "0 0 77.222 69.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 77.222,
    height: 69.958,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M219.168,0H191.893V32.514h12.728l.028-2.782H226.42v-9.99A30.911,30.911,0,0,0,221.154,2.8ZM204.754,19.742V4.071c.166-.011.293.127.42.216a21.54,21.54,0,0,1,4.481,4.431,19.815,19.815,0,0,1,3.883,11.024Z",
    transform: "translate(-152.404)",
    fill: "#ffb624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M21.346,168.192a30.91,30.91,0,0,0-5.266,16.943v9.99H37.852l.028,2.782H50.607V165.393H23.332Zm7.617,16.943a19.815,19.815,0,0,1,3.883-11.024,21.54,21.54,0,0,1,4.481-4.431c.127-.088.254-.227.42-.216v15.671Z",
    transform: "translate(-12.771 -131.358)",
    fill: "#0bc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M215.466,184.424a27.81,27.81,0,0,0-3.756,13.475H202.1a35.57,35.57,0,0,1,4.341-17.486c.482-.874,1.111-1.7,1.57-2.535a.379.379,0,0,0,.071-.288h-7.594V197.9h-8.6V165.383h34.527V197.9h-8.653l-.1-.122V181.029",
    transform: "translate(-152.404 -131.35)",
    fill: "#ff4d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M37.835,0V32.519H28.559C9.763,32.519,0,17.058,0,0H14.227a32.782,32.782,0,0,0,8.612,17.452h.149V0Z",
    transform: "translate(0 -0.004)",
    fill: "#f53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.83b43dcbf3052fc8e95ed70ced11502f.svg";
export { ForwardRef as ReactComponent };